export const africaGeoURL = {
  type: "Topology",
  arcs: [
    [
      [4143, 2035],
      [3, -181],
      [-171, 0],
      [1, -269],
      [14, -37],
      [104, -88],
    ],
    [
      [4094, 1460],
      [-169, -32],
      [-49, -2],
      [-172, 25],
      [-27, 30],
      [-156, 0],
      [-224, -2],
      [-49, 38],
      [-69, -23],
      [-66, -1],
    ],
    [
      [3113, 1493],
      [-3, 115],
      [46, 97],
      [20, 113],
      [95, 100],
      [17, 97],
      [-7, 39],
      [-47, 80],
      [-17, 52],
      [32, 29],
      [-1, 37],
      [-47, 117],
      [-45, 68],
      [77, 25],
    ],
    [
      [3233, 2462],
      [264, 0],
      [24, -6],
      [33, -117],
      [46, -61],
      [154, 1],
      [14, 85],
      [65, 0],
      [19, -24],
      [107, 0],
      [13, -96],
      [-7, -102],
      [39, -64],
      [-13, -41],
      [72, -21],
      [80, 19],
    ],
    [
      [3223, 2565],
      [-46, -44],
      [-27, -51],
    ],
    [
      [3150, 2470],
      [-17, 63],
    ],
    [
      [3133, 2533],
      [64, 53],
      [26, -21],
    ],
    [
      [4700, 2755],
      [-12, -38],
      [35, -27],
      [-70, -94],
      [-51, -15],
    ],
    [
      [4602, 2581],
      [-16, 47],
      [2, 73],
      [-18, 27],
    ],
    [
      [4570, 2728],
      [57, -7],
      [73, 34],
    ],
    [
      [2423, 3954],
      [-10, -26],
      [30, -67],
      [-27, -64],
      [-63, -67],
      [-8, -100],
      [2, -129],
    ],
    [
      [2347, 3501],
      [-91, -13],
    ],
    [
      [2256, 3488],
      [-2, 241],
      [-23, 81],
      [-47, 31],
      [11, 53],
    ],
    [
      [2195, 3894],
      [94, 37],
      [32, 40],
    ],
    [
      [2321, 3971],
      [38, 43],
      [64, -60],
    ],
    [
      [2138, 4227],
      [-6, -31],
      [69, -125],
      [93, -65],
      [27, -35],
    ],
    [
      [2195, 3894],
      [-90, 12],
    ],
    [
      [2105, 3906],
      [-30, -12],
      [-188, 0],
      [5, -128],
    ],
    [
      [1892, 3766],
      [-81, 39],
      [-53, -17],
      [-58, 13],
      [-47, 45],
    ],
    [
      [1653, 3846],
      [30, 129],
      [64, 31],
      [36, 93],
      [62, -9],
      [34, 64],
      [69, 13],
      [107, 74],
      [83, -14],
    ],
    [
      [4252, 1447],
      [58, -96],
      [16, -49],
      [132, -86],
      [-2, -50],
      [27, -39],
      [89, -21],
      [26, -33],
    ],
    [
      [4598, 1073],
      [-82, -33],
      [-116, -91],
      [-13, -51],
      [-82, -54],
      [-25, -63],
      [-67, -18],
      [-73, 17],
      [-40, 30],
      [-38, -2],
      [-24, -58],
      [-87, -74],
      [-90, 6],
      [14, 76],
      [-36, 73],
      [-32, 24],
    ],
    [
      [3807, 855],
      [-1, 234],
      [84, 0],
      [1, 313],
      [192, 27],
      [33, -39],
      [35, 29],
      [101, 28],
    ],
    [
      [4050, 3888],
      [64, -86],
      [-12, -96],
      [58, -8],
    ],
    [
      [4160, 3698],
      [-3, -29],
      [59, -15],
      [45, -71],
      [86, -58],
      [14, -53],
      [49, -22],
      [27, -59],
    ],
    [
      [4437, 3391],
      [-83, -1],
      [-74, 27],
      [-24, -30],
      [-71, 7],
      [-91, -44],
      [-41, 20],
      [-34, -56],
      [-160, 20],
      [-74, 62],
      [-54, -19],
      [-31, -45],
      [-8, -77],
    ],
    [
      [3692, 3255],
      [-109, 12],
      [-65, -13],
      [-31, -104],
    ],
    [
      [3487, 3150],
      [-9, 53],
      [-85, 87],
      [-47, 118],
      [16, 84],
      [65, 107],
    ],
    [
      [3427, 3599],
      [75, 13],
      [33, -10],
      [77, 37],
      [77, 5],
      [45, 53],
      [-2, 29],
      [107, 9],
      [109, 95],
      [6, 34],
      [62, 31],
      [34, -7],
    ],
    [
      [1856, 3394],
      [0, -2],
    ],
    [
      [1856, 3392],
      [0, 2],
    ],
    [
      [1892, 3766],
      [15, -108],
      [-28, -34],
      [-35, -102],
      [35, -125],
    ],
    [
      [1879, 3397],
      [-108, 14],
      [-146, -24],
      [-143, -57],
    ],
    [
      [1482, 3330],
      [-5, 46],
      [13, 81],
      [-94, 60],
      [23, 39],
      [-17, 46],
    ],
    [
      [1402, 3602],
      [31, 13],
      [22, 145],
      [-25, 14],
      [14, 50],
    ],
    [
      [1444, 3824],
      [24, 20],
      [62, -20],
      [59, 47],
      [22, -45],
      [42, 20],
    ],
    [
      [3487, 3150],
      [-36, -28],
      [-102, 25],
      [-107, -4],
    ],
    [
      [3242, 3143],
      [-164, 12],
      [-3, -11],
    ],
    [
      [3075, 3144],
      [-112, 0],
      [-16, 15],
    ],
    [
      [2947, 3159],
      [8, 79],
      [-78, 70],
      [-32, 61],
    ],
    [
      [2845, 3369],
      [22, 88],
      [107, 97],
      [41, 6],
      [76, -38],
      [58, 116],
      [5, 37],
      [46, 32],
      [5, 50],
      [29, 14],
      [4, 46],
      [62, 101],
      [52, 19],
      [6, 57],
      [-38, 16],
      [-13, 62],
    ],
    [
      [3307, 4072],
      [30, 0],
      [35, -40],
      [25, -92],
      [-6, -63],
      [40, -60],
      [-113, -9],
      [-21, -29],
      [104, -98],
      [26, -82],
    ],
    [
      [4437, 3391],
      [28, -41],
      [53, -27],
      [30, 24],
      [46, -14],
      [42, 14],
      [34, -52],
      [54, -39],
    ],
    [
      [4724, 3256],
      [-10, -89],
      [44, -33],
      [-111, -108],
      [-19, -58],
      [-11, -126],
    ],
    [
      [4617, 2842],
      [-61, -88],
      [14, -26],
    ],
    [
      [4602, 2581],
      [-6, -40],
      [22, -59],
      [-9, -33],
      [22, -55],
      [53, -56],
      [32, -75],
    ],
    [
      [4716, 2263],
      [-155, -24],
      [-46, -65],
      [26, -48],
      [-19, -168],
      [49, -51],
      [65, 19],
      [-19, -91],
      [-34, -18],
      [-63, 78],
      [-67, 19],
      [-18, 32],
      [-121, 1],
      [-54, 22],
      [-19, 33],
      [-98, 33],
    ],
    [
      [3233, 2462],
      [-62, -17],
      [-21, 25],
    ],
    [
      [3223, 2565],
      [24, -13],
      [86, 44],
      [2, -49],
      [37, 3],
      [31, 41],
      [57, 33],
      [28, 50],
      [2, 105],
      [51, 73],
      [77, 63],
      [16, 75],
      [-6, 56],
      [17, 97],
      [46, 83],
      [1, 29],
    ],
    [
      [3133, 2533],
      [-17, 37],
      [-58, 55],
    ],
    [
      [3058, 2625],
      [60, 33],
      [-23, 102],
      [123, 0],
      [74, -12],
      [29, 14],
      [21, 79],
      [2, 65],
      [-53, 70],
      [50, 61],
      [-24, 40],
      [-79, -14],
      [4, 80],
    ],
    [
      [5771, 3936],
      [-27, -41],
    ],
    [
      [5744, 3895],
      [-95, -3],
      [-4, 49],
      [53, 78],
    ],
    [
      [5698, 4019],
      [63, 21],
    ],
    [
      [5761, 4040],
      [22, -60],
      [-12, -44],
    ],
    [
      [2846, 6100],
      [-17, -25],
      [-14, -170],
      [-64, -64],
      [23, -58],
      [48, -55],
      [61, -42],
      [40, -156],
    ],
    [
      [2923, 5530],
      [26, -94],
      [-4, -73],
      [13, -34],
      [-18, -49],
      [10, -67],
      [-37, -33],
      [48, -61],
      [5, -46],
      [130, -50],
      [34, -64],
    ],
    [
      [3130, 4959],
      [-104, -61],
      [-275, -164],
      [-139, -118],
      [-136, -29],
    ],
    [
      [2476, 4587],
      [-77, -14],
      [-8, 70],
      [-112, 37],
      [-63, 48],
      [0, 26],
      [-281, 184],
      [-223, 147],
    ],
    [
      [1712, 5085],
      [-176, 105],
      [-150, 89],
    ],
    [
      [1386, 5279],
      [0, 32],
    ],
    [
      [1386, 5311],
      [0, 86],
      [90, 61],
      [157, 19],
      [117, 77],
      [61, 17],
      [-1, 79],
      [70, 13],
      [27, 29],
      [107, -5],
      [2, 27],
      [-38, 72],
      [-10, 129],
      [-37, 28],
    ],
    [
      [1931, 5943],
      [276, 119],
      [134, 10],
      [26, 17],
      [156, 8],
      [44, -22],
      [166, 36],
      [54, -18],
      [59, 7],
    ],
    [
      [5234, 4830],
      [-196, 0],
      [-280, 0],
      [-250, 0],
      [-279, 0],
    ],
    [
      [4229, 4830],
      [0, 248],
      [0, 234],
      [0, 129],
      [-25, 82],
      [26, 54],
      [-11, 51],
      [24, 23],
    ],
    [
      [4243, 5651],
      [183, -23],
      [145, -47],
      [112, 58],
      [73, 6],
      [70, -43],
      [135, 3],
      [46, 17],
      [53, -134],
      [-16, -82],
      [-35, -85],
      [-59, -12],
      [42, -87],
      [126, -224],
      [16, -89],
      [100, -79],
    ],
    [
      [5698, 4019],
      [-130, 140],
      [-62, 31],
      [-142, -5],
      [-45, 40],
      [-27, -65],
      [-88, 12],
    ],
    [
      [5204, 4172],
      [-9, 72],
      [44, 97],
      [5, 70],
      [113, 50],
      [22, 29],
    ],
    [
      [5379, 4490],
      [28, -51],
      [26, -110],
      [21, -42],
      [36, -13],
      [21, -41],
      [84, -29],
      [44, -59],
      [52, -31],
      [40, -59],
      [30, -15],
    ],
    [
      [758, 5389],
      [-47, -49],
      [-21, 30],
      [68, 19],
    ],
    [
      [5744, 3895],
      [-7, -67],
      [49, -68],
      [51, -36],
      [250, -85],
      [84, 0],
    ],
    [
      [6171, 3639],
      [-128, -124],
    ],
    [
      [6043, 3515],
      [-128, -138],
      [-82, 4],
      [-72, -26],
      [-28, -31],
      [-76, -26],
    ],
    [
      [5657, 3298],
      [-66, -2],
      [-29, 28],
      [-77, -36],
      [-35, -34],
      [-113, 13],
      [-106, 69],
      [-78, 16],
    ],
    [
      [5153, 3352],
      [-10, 60],
      [-60, 26],
      [-30, 86],
      [-86, 87],
      [-57, 12],
      [11, 51],
      [67, 4],
      [9, 85],
    ],
    [
      [4997, 3763],
      [17, 95],
      [57, 60],
      [56, 111],
      [43, 12],
      [34, 131],
    ],
    [
      [3058, 2625],
      [-41, 53],
      [-62, 52],
      [-55, 78],
      [-38, 89],
      [40, 28],
      [3, 87],
      [42, 32],
    ],
    [
      [2947, 3044],
      [130, 1],
      [-2, 99],
    ],
    [
      [2105, 3906],
      [6, -41],
      [39, -29],
      [0, -130],
      [21, -25],
      [3, -99],
      [-11, -42],
      [56, -62],
    ],
    [
      [2219, 3478],
      [-167, -75],
      [-109, -41],
      [-87, 30],
    ],
    [
      [1856, 3394],
      [23, 3],
    ],
    [
      [1157, 4014],
      [57, -43],
      [38, 27],
      [46, -16],
      [62, 31],
      [12, -62],
      [46, -58],
      [26, -69],
    ],
    [
      [1402, 3602],
      [-37, -26],
      [-43, 15],
      [1, 51],
      [-22, 39],
      [-50, 0],
    ],
    [
      [1251, 3681],
      [-33, 70],
      [-51, 58],
      [-104, -11],
      [-17, -37],
      [-50, -33],
    ],
    [
      [996, 3728],
      [-28, 52],
      [-87, 73],
      [-31, 39],
    ],
    [
      [850, 3892],
      [29, 46],
      [81, 17],
      [0, 82],
    ],
    [
      [960, 4037],
      [55, -3],
      [60, -28],
      [82, 8],
    ],
    [
      [704, 4070],
      [16, 45],
    ],
    [
      [720, 4115],
      [88, -1],
      [-26, -36],
      [-78, -8],
    ],
    [
      [850, 3892],
      [-28, 15],
      [-19, 60],
      [-33, -7],
      [-64, 48],
    ],
    [
      [706, 4008],
      [89, 9],
      [41, 21],
      [124, -1],
    ],
    [
      [2947, 3044],
      [-33, 25],
      [33, 52],
      [0, 38],
    ],
    [
      [5657, 3298],
      [-78, -99],
      [1, -313],
      [47, -71],
    ],
    [
      [5627, 2815],
      [-53, -32],
      [-7, -25],
      [-55, -33],
      [-4, -42],
      [-49, -98],
      [-30, -23],
    ],
    [
      [5429, 2562],
      [-120, 87],
      [-11, 52],
      [-206, 116],
      [-110, 57],
    ],
    [
      [4982, 2874],
      [0, 95],
      [91, 133],
      [-4, 68],
      [-41, 58],
      [-39, 90],
    ],
    [
      [4989, 3318],
      [34, 34],
      [73, 31],
      [57, -31],
    ],
    [
      [1482, 3330],
      [-60, 19],
      [-87, 48],
      [-94, 88],
      [-81, 44],
      [-10, 19],
    ],
    [
      [1150, 3548],
      [73, 72],
      [28, 61],
    ],
    [
      [4229, 4830],
      [-1, -170],
      [-84, 0],
      [0, -43],
    ],
    [
      [4144, 4617],
      [-250, 125],
      [-125, 62],
      [-300, 149],
      [-85, -38],
    ],
    [
      [3384, 4915],
      [-63, -32],
      [-63, 47],
      [-128, 29],
    ],
    [
      [2923, 5530],
      [63, 58],
      [-13, 42],
      [64, 62],
      [49, 20],
      [5, 69],
    ],
    [
      [3091, 5781],
      [71, -30],
      [85, 6],
      [155, -44],
      [25, -61],
      [47, -33],
      [112, -16],
      [68, -26],
      [67, -43],
      [31, 2],
      [59, 44],
      [-9, 76],
      [54, 72],
      [88, 31],
      [125, -24],
      [1, -27],
      [84, -27],
      [75, -3],
      [14, -27],
    ],
    [
      [4567, 502],
      [38, -37],
      [-24, -49],
      [-66, -21],
      [-27, -41],
      [-58, 30],
      [-29, 57],
      [62, 61],
      [77, 26],
      [27, -26],
    ],
    [
      [1663, 6014],
      [5, -7],
    ],
    [
      [1668, 6007],
      [48, -51],
      [34, -8],
      [120, 15],
    ],
    [
      [1870, 5963],
      [3, -4],
    ],
    [
      [1873, 5959],
      [58, -16],
    ],
    [
      [1386, 5311],
      [-6, -40],
      [-83, -28],
      [-100, 13],
      [-68, -77],
      [-26, -6],
      [-34, -102],
      [-53, -37],
      [-21, -36],
      [-57, -39],
      [-20, -103],
      [-52, -73],
      [-184, -2],
    ],
    [
      [682, 4781],
      [17, 60],
      [101, 161],
      [60, 56],
      [11, 65],
      [31, 69],
      [67, 37],
      [55, 104],
      [125, 35],
      [77, 56],
      [78, 97],
      [-17, 109],
      [41, 53],
      [9, 46],
      [86, 71],
      [120, 54],
      [45, 71],
      [31, 77],
      [44, 12],
    ],
    [
      [6287, 1932],
      [50, -81],
      [29, -157],
      [18, -37],
      [-22, -54],
      [-51, 35],
      [18, -86],
      [-35, -62],
      [-6, -97],
      [-68, -183],
      [-55, -162],
      [-28, -116],
      [-37, -90],
      [-139, -57],
      [-95, 27],
      [-28, 22],
      [-32, 69],
      [-6, 95],
      [-31, 69],
      [22, 73],
      [85, 127],
      [-2, 42],
      [-35, 84],
      [-9, 82],
      [78, 105],
      [124, 51],
      [120, 87],
      [16, 51],
      [71, 53],
      [15, 48],
      [-16, 31],
      [49, 31],
    ],
    [
      [2476, 4587],
      [-4, -232],
      [-26, -59],
      [-31, -31],
      [-183, -6],
      [-31, -25],
      [-63, -7],
    ],
    [
      [1157, 4014],
      [-5, 57],
      [-46, 40],
      [0, 53],
      [-23, 52],
    ],
    [
      [1083, 4216],
      [25, 0],
      [21, 65],
      [159, -15],
      [41, 11],
      [325, 0],
      [13, 69],
      [-23, 19],
      [-36, 327],
      [-19, 164],
      [-27, 229],
      [150, 0],
    ],
    [
      [4897, 677],
      [-66, 1],
    ],
    [
      [4831, 678],
      [-14, 75],
    ],
    [
      [4817, 753],
      [4, 130],
      [-40, 86],
      [-19, 86],
    ],
    [
      [4762, 1055],
      [94, 94],
      [5, 52],
      [48, 76],
      [-22, 36],
      [19, 76],
      [2, 94],
      [-10, 56],
      [-84, 24],
      [-55, 34],
      [-72, 2],
      [-1, 31],
    ],
    [
      [4686, 1630],
      [-15, 56],
      [252, 82],
    ],
    [
      [4923, 1768],
      [34, -43],
      [63, 11],
      [19, -75],
      [-29, -52],
      [13, -26],
      [70, -25],
      [49, 41],
      [5, 113],
      [-81, 97],
      [-29, 18],
      [-17, 95],
      [26, 54],
      [26, 0],
    ],
    [
      [5072, 1976],
      [104, -11],
      [53, 11],
      [51, -13],
      [38, 34],
      [52, -8],
      [128, 51],
      [36, 29],
    ],
    [
      [5534, 2069],
      [14, -29],
      [-18, -44],
      [13, -56],
      [6, -183],
      [19, -27],
      [-22, -89],
      [-66, -81],
      [-59, -44],
      [-100, -32],
      [-52, -28],
      [-89, -102],
      [-49, -21],
      [-66, -62],
      [-17, -41],
      [69, -153],
      [-3, -172],
      [-30, -37],
      [-116, -43],
      [-73, -37],
      [-16, -55],
      [18, -56],
    ],
    [
      [1083, 4216],
      [-175, 158],
      [-167, -12],
      [-19, -58],
    ],
    [
      [722, 4304],
      [7, 71],
      [37, 112],
      [-15, 87],
      [-23, 24],
      [23, 80],
      [-16, 30],
      [-56, 17],
    ],
    [
      [679, 4725],
      [8, 48],
      [333, 0],
      [0, 144],
      [84, 40],
      [0, 213],
      [282, 1],
      [0, 108],
    ],
    [
      [4923, 1768],
      [-40, 38],
      [23, 30],
      [22, 97],
      [2, 99],
      [33, 28],
      [-42, 83],
      [-22, 17],
    ],
    [
      [4899, 2160],
      [41, -17],
      [52, 11],
      [39, -40],
      [10, -91],
      [31, -47],
    ],
    [
      [4094, 1460],
      [71, 13],
      [62, -6],
      [25, -20],
    ],
    [
      [3807, 855],
      [0, -312],
      [-76, -46],
      [-142, 22],
      [-5, 41],
      [-38, 12],
      [-34, -42],
    ],
    [
      [3512, 530],
      [-68, 53],
      [-33, 54],
      [-38, 132],
      [-6, 82],
      [-27, 69],
      [4, 122],
      [-94, 148],
      [-20, 56],
      [-73, 124],
      [-37, 47],
      [-7, 76],
    ],
    [
      [3384, 4915],
      [17, -127],
      [65, -96],
      [-18, -40],
      [-24, -258],
      [-91, -95],
      [-78, -117],
      [13, -57],
    ],
    [
      [3268, 4125],
      [-132, -49],
      [-51, 20],
      [-64, 1],
      [-63, -20],
      [-25, -27],
      [-81, 8],
      [-78, 35],
      [-72, -28],
      [-45, 53],
      [-69, 21],
      [-88, -15],
      [-32, -19],
      [-4, -40],
      [-37, -40],
      [-4, -71],
    ],
    [
      [3268, 4125],
      [39, -53],
    ],
    [
      [2845, 3369],
      [-25, -22],
      [-95, 4],
      [-17, -19],
      [-73, -9],
      [-43, 31],
      [-50, 103],
      [-51, 43],
      [-73, 8],
      [-71, -7],
    ],
    [
      [4693, 2869],
      [30, -45],
      [0, -64],
      [-23, -5],
    ],
    [
      [4617, 2842],
      [47, 2],
      [29, 25],
    ],
    [
      [679, 4725],
      [3, 56],
    ],
    [
      [5234, 4830],
      [23, -70],
      [7, -129],
      [17, -68],
      [98, -73],
    ],
    [
      [4997, 3763],
      [-15, 63],
      [-60, 56],
      [-9, 63],
      [11, 53],
      [-73, -43],
      [6, -56],
      [-100, -107],
      [-41, -5],
      [-62, 46],
      [-99, -81],
      [-67, 1],
      [-13, 22],
      [-113, -6],
      [-60, 76],
      [-64, -10],
      [-25, -42],
      [-20, -78],
      [-33, -17],
    ],
    [
      [4050, 3888],
      [-23, 91],
      [-33, 64],
      [-11, 87],
      [71, 115],
      [16, 50],
      [75, 1],
      [-1, 321],
    ],
    [
      [4989, 3318],
      [-38, -38],
      [-43, 9],
      [-91, -24],
      [-68, 16],
      [-25, -25],
    ],
    [
      [1663, 6014],
      [5, -7],
    ],
    [
      [1870, 5963],
      [3, -4],
    ],
    [
      [706, 4008],
      [-2, 62],
    ],
    [
      [720, 4115],
      [-52, 90],
      [54, 99],
    ],
    [
      [1150, 3548],
      [-87, 40],
      [-31, 37],
      [-36, 103],
    ],
    [
      [6252, 3916],
      [0, -153],
      [-81, -124],
    ],
    [
      [5771, 3936],
      [87, -87],
      [58, -4],
      [71, 39],
      [55, -15],
      [77, 41],
      [133, 6],
    ],
    [
      [6253, 3470],
      [-210, 45],
    ],
    [
      [6252, 3916],
      [113, 29],
      [44, 34],
      [28, -41],
      [1, -71],
      [-18, -29],
      [-7, -74],
      [-47, -83],
      [-37, -44],
      [-76, -167],
    ],
    [
      [6253, 3470],
      [-84, -131],
      [-163, -172],
      [-124, -75],
      [-92, -80],
      [-117, -126],
      [-46, -71],
    ],
    [
      [4831, 678],
      [-12, -41],
      [-69, 9],
      [-31, 42],
      [28, 69],
      [70, -4],
    ],
    [
      [2256, 3488],
      [-37, -10],
    ],
    [
      [2846, 6100],
      [89, 34],
      [74, -48],
      [6, -78],
      [43, -55],
      [-44, -56],
      [-40, -19],
      [18, -53],
      [65, -13],
      [34, -31],
    ],
    [
      [5429, 2562],
      [-35, -115],
      [6, -27],
      [52, -43],
      [-16, -63],
      [0, -61],
      [31, -75],
      [13, -62],
      [54, -47],
    ],
    [
      [4899, 2160],
      [-165, 73],
      [-18, 30],
    ],
    [
      [4693, 2869],
      [30, 5],
      [259, 0],
    ],
    [
      [4897, 677],
      [-43, -145],
      [-101, -86],
      [-67, -109],
      [-129, -123],
      [-82, -64],
      [-117, -60],
      [-47, 3],
      [-30, -28],
      [-63, -12],
      [-103, 17],
      [-85, -1],
      [-78, -33],
      [-100, -6],
      [-48, -30],
      [-96, 38],
      [-81, 130],
      [35, 16],
      [-8, 83],
      [-75, 112],
      [-40, 108],
      [-27, 43],
    ],
    [
      [4598, 1073],
      [164, -18],
    ],
    [
      [4686, 1630],
      [-102, -15],
      [-38, -63],
      [-73, -32],
      [-70, -86],
      [-151, 13],
    ],
  ],
  transform: {
    scale: [0.011840545025277828, 0.011761343021418996],
    translate: [-25.091177335660404, -34.80859368564344],
  },
  objects: {
    continent_Africa_subunits: {
      type: "GeometryCollection",
      geometries: [
        {
          arcs: [[[0, 1, 2, 3]], [[4, 5, 6]]],
          type: "MultiPolygon",
          properties: { type: "Sovereign country", geounit: "Angola" },
        },
        {
          arcs: [[7, 8, 9]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Burundi" },
        },
        {
          arcs: [[10, 11, 12, 13, 14]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Benin" },
        },
        {
          arcs: [[15, -14, 16, 17, 18, 19]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Burkina Faso" },
        },
        {
          type: null,
          properties: {
            type: "Geo subunit",
            geounit: "French Southern and Antarctic Lands",
          },
        },
        {
          arcs: [[20, 21, 22]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Botswana" },
        },
        {
          arcs: [[23, 24, 25, 26, 27, 28]],
          type: "Polygon",
          properties: {
            type: "Sovereign country",
            geounit: "Central African Republic",
          },
        },
        {
          arcs: [[-19, 31, 32, 33, 34, 35]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Ivory Coast" },
        },
        {
          arcs: [[-28, 36, 37, 38, 39, 40, 41]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Cameroon" },
        },
        {
          arcs: [[42, 43, 44, -9, 45, 46, -4, 47, -5, 48, -26]],
          type: "Polygon",
          properties: {
            type: "Sovereign country",
            geounit: "Democratic Republic of the Congo",
          },
        },
        {
          arcs: [[-49, -7, 49, 50, -37, -27]],
          type: "Polygon",
          properties: {
            type: "Sovereign country",
            geounit: "Republic of Congo",
          },
        },
        {
          type: null,
          properties: { type: "Sovereign country", geounit: "Comoros" },
        },
        {
          type: null,
          properties: { type: "Sovereign country", geounit: "Cape Verde" },
        },
        {
          arcs: [[51, 52, 53, 54]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Djibouti" },
        },
        {
          arcs: [[55, 56, 57, 58, 59, 60, 61, 62]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Algeria" },
        },
        {
          arcs: [[63, 64, 65]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Egypt" },
        },
        {
          arcs: [[-54, 66, 67, 68]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Eritrea" },
        },
        {
          arcs: [[69]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "Spain" },
        },
        {
          arcs: [[-53, 70, 71, 72, 73, 74, 75, -67]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Ethiopia" },
        },
        {
          type: null,
          properties: {
            type: "Geo subunit",
            geounit: "French Southern and Antarctic Lands",
          },
        },
        {
          arcs: [[-51, 76, 77, -38]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Gabon" },
        },
        {
          arcs: [[78, 79, -30, 80, -32, -18]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Ghana" },
        },
        {
          arcs: [[81, -35, 82, 83, 84, 85, 86]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Guinea" },
        },
        {
          arcs: [[87, 88]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Gambia" },
        },
        {
          type: null,
          properties: { type: "Geo subunit", geounit: "Equatorial Guinea" },
        },
        {
          arcs: [[89, 90, -86]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Guinea Bissau" },
        },
        {
          type: null,
          properties: { type: "Geo subunit", geounit: "Equatorial Guinea" },
        },
        {
          arcs: [[-78, 91, -39]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "Equatorial Guinea" },
        },
        {
          type: null,
          properties: {
            type: "Geo subunit",
            geounit: "French Southern and Antarctic Lands",
          },
        },
        {
          arcs: [[-74, 92, 93, 94, 95, 96]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Kenya" },
        },
        {
          arcs: [[-34, 97, 98, -83]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Liberia" },
        },
        {
          arcs: [[-65, 99, 100, 101, -57, 102, 103]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Libya" },
        },
        {
          arcs: [[104]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Lesotho" },
        },
        {
          arcs: [[105, 106, 107, 108, -62, 109, 110]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Morocco" },
        },
        {
          arcs: [[111]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Madagascar" },
        },
        {
          arcs: [[112, -20, -36, -82, 113, 114, -59]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Mali" },
        },
        {
          arcs: [[115, 116, 117, 118, 119, 120, 121, 122]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Mozambique" },
        },
        {
          arcs: [[123, 124, 125, -60, -115]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Mauritania" },
        },
        {
          arcs: [[-121, 126, 127]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Malawi" },
        },
        { type: null, properties: { type: "Geo unit", geounit: "Mayotte" } },
        {
          arcs: [[128, -23, 129, 130, -2]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Namibia" },
        },
        {
          arcs: [[131, 132, -15, -16, -113, -58, -102]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Niger" },
        },
        {
          arcs: [[133, -41, 134, -11, -133]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Nigeria" },
        },
        { type: null, properties: { type: "Geo unit", geounit: "Madeira" } },
        {
          arcs: [[135, -10, -45, 136]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Rwanda" },
        },
        {
          arcs: [[-61, -126, 137, -110]],
          type: "Polygon",
          properties: { type: "Indeterminate", geounit: "Western Sahara" },
        },
        {
          arcs: [[138, -68, -76, 139, -24, 140, -100, -64]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Sudan" },
        },
        {
          arcs: [[-75, -97, 141, -43, -25, -140]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "South Sudan" },
        },
        {
          arcs: [[-106, 142]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "Spain" },
        },
        {
          arcs: [[-108, 143]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "Spain" },
        },
        {
          arcs: [[-114, -87, -91, 144, -89, 145, -124]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Senegal" },
        },
        {
          arcs: [[-99, 146, -84]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Sierra Leone" },
        },
        {
          arcs: [[147, -71, -52, 148]],
          type: "Polygon",
          properties: { type: "Indeterminate", geounit: "Somaliland" },
        },
        {
          arcs: [[149, -72, -148, 150]],
          type: "Polygon",
          properties: { type: "Geo unit", geounit: "Puntland" },
        },
        {
          arcs: [[151, -93, -73, -150]],
          type: "Polygon",
          properties: { type: "Geo unit", geounit: "Somalia" },
        },
        {
          type: null,
          properties: { type: "Geo subunit", geounit: "Sao Tome and Principe" },
        },
        {
          type: null,
          properties: { type: "Geo subunit", geounit: "Sao Tome and Principe" },
        },
        {
          arcs: [[-117, 152]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Swaziland" },
        },
        {
          arcs: [[-141, -29, -42, -134, -132, -101]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Chad" },
        },
        {
          arcs: [[-13, 153, -79, -17]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Togo" },
        },
        {
          arcs: [[-103, -56, 154]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Tunisia" },
        },
        {
          arcs: [[-95, 155, -122, -128, 156, -46, -8, -136, 157]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Tanzania" },
        },
        { type: null, properties: { type: "Geo unit", geounit: "Zanzibar" } },
        {
          arcs: [[-158, -137, -44, -142, -96]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Uganda" },
        },
        {
          arcs: [[-118, -153, -116, 158, -130, -22, 159], [-105]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "South Africa" },
        },
        {
          arcs: [[-127, -120, 160, -129, -1, -47, -157]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Zambia" },
        },
        {
          arcs: [[-119, -160, -21, -161]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Zimbabwe" },
        },
      ],
    },
  },
};
